import { GeneratingDots } from '@/components/glitch-ui/generating-dots';

export function LandingPageGenerating() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <GeneratingDots count={4} />
      <h3 className="text-lg font-semibold text-gray-900 mt-4 mb-1">Generating Landing Page</h3>
      <p className="text-gray-700">
        The page is being built from this campaign's keywords, ad copy, and brand. This can take a few minutes.
      </p>
    </div>
  );
}
